import get from "lodash/get";
import { Compare } from "@/common/types/Compare";

export const compareFilter = <T>(a: T, b: T, compare: Compare): boolean => {
  if (compare.condition.length < 1) {
    return true;
  }

  for (const condition of compare.condition) {
    const n = get(a, condition.key) - get(b, condition.key);

    if (n > 0 && condition.operator > 0) {
      if (!compare.and) {
        return true;
      }
      continue;
    }
    if (n === 0 && Math.abs(condition.operator) < 2) {
      if (!compare.and) {
        return true;
      }
      continue;
    }
    if (n < 0 && condition.operator < 0) {
      if (!compare.and) {
        return true;
      }
      continue;
    }
    if (compare.and) {
      return false;
    }
  }
  return Boolean(compare.and);
};
